import { render, staticRenderFns } from "./datacollect-form-5.vue?vue&type=template&id=7023bbec&scoped=true&"
import script from "./datacollect-form-5.vue?vue&type=script&lang=ts&"
export * from "./datacollect-form-5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023bbec",
  null
  
)

export default component.exports